import React from 'react';
import { Card, CardBody, CardTitle, Col, Row, Table, Label } from 'reactstrap';
import { Link } from 'react-router-dom';
import { compact } from 'underscore';
import cx from 'classnames';
import URI from 'urijs';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../partials.module.scss';

function AssistedLivingCard({ data, className, tag = Card, searchURI, detailURI }) {
  const Tag = tag;

  const physicalAddress = compact([
    (data.physicalAddress || '').trim(),
    (data.physicalCity || '').trim(),
    compact([(data.physicalState || '').trim(), (data.physicalZip || '').trim()]).join(
      ' '
    )
  ]).join(', ');

  const mailingAddress = compact([
    (data.mailingAddress || '').trim(),
    (data.mailingCity || '').trim(),
    compact([(data.mailingState || '').trim(), (data.mailingZip || '').trim()]).join(' ')
  ]).join(', ');

  return (
    <Tag className={cx(className, styles.assistedLivingCard)}>
      <CardBody>
        <CardTitle>
          <Link
            to={URI(`/assisted-living/${data.ahcaNumber}`)
              .search({
                searchURI,
                detailURI
              })
              .toString()}
          >
            {data.facilityName}
          </Link>
        </CardTitle>
        <Row>
          <Col md={6}>
            <Label className={BS.dBlock}>Physical Address:</Label>
            <div>{physicalAddress}</div>
            <Label className={BS.dBlock}>Mailing Address:</Label>
            <div>{mailingAddress}</div>
          </Col>
          <Col md={6}>
            <Table size="sm">
              <tbody>
                <tr>
                  <td>
                    <Label>AHCA Number:</Label>
                  </td>
                  <td>{data.ahcaNumber}</td>
                  <td>
                    <Label>License Number:</Label>
                  </td>
                  <td>{data.licenseNumber}</td>
                </tr>
                <tr>
                  <td>
                    <Label>Facility Type:</Label>
                  </td>
                  <td>{data.facilityType}</td>
                  <td>
                    <Label>License Status:</Label>
                  </td>
                  <td>{data.licenseStatus}</td>
                </tr>
                <tr>
                  <td>
                    <Label>Profit Status:</Label>
                  </td>
                  <td>{data.profitStatus}</td>
                  <td>
                    <Label>Licensed Beds:</Label>
                  </td>
                  <td>{data.licensedBeds}</td>
                </tr>
                <tr>
                  <td>
                    <Label>Phone:</Label>
                  </td>
                  <td>{data.phone}</td>
                  <td />
                  <td />
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </CardBody>
    </Tag>
  );
}

export default AssistedLivingCard;



// WEBPACK FOOTER //
// ./src/partials/assisted-living-card/assisted-living-card.js